module.exports = __webpack_public_path__ + "de9cb57a032ef571f83a1bd1a7cd5a50.svg";